import { FileFull } from "../files/file-full";

export class CreateContractSignature {
    
  contractId: number;
	user: string;
	country: string;
  
	files: FileFull = new FileFull();

  constructor() {
  }
}